export default "__VITE_ASSET__CRszXXjr__"